<template>
    <div id="app">
        <div class="col-sm-6" style="float:left;">
            <div class="card" v-if="results.Stats">
                <div class="card-body table-responsive">
                    <h5 class="card-title">Pilgrims Offense</h5>
                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th></th>
                                <th scope="col">Pass TD</th>
                                <th scope="col">KR TD</th>
                                <th scope="col">Rush TD</th>
                                <th scope="col">Rec TD</th>
                                <th scope="col">Fum</th>
                                <th scope="col">INT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(player, index) in results.Stats.Pilgrims.Offense.Players" v-bind:key="index">
                                <td>{{player.FirstName}} {{player.LastName}}</td>
                                <td>{{player.PassingTDs}}</td>
                                <td>{{player.KickReturnTDs}}</td>
                                <td>{{player.RushingTDs}}</td>
                                <td>{{player.ReceivingTDs}}</td>
                                <td>{{player.Fumbles}}</td>
                                <td>{{player.INTs}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-sm-6" style="float:left;">
            <div class="card" v-if="results.Stats">
                <div class="card-body table-responsive">
                    <h5 class="card-title">Indians Offense</h5>
                    <table class="table table-sm">
                        <thead>
                            <tr>
                                <th scope="col"></th>
                                <th scope="col">Pass TD</th>
                                <th scope="col">KR TD</th>
                                <th scope="col">Rush TD</th>
                                <th scope="col">Rec TD</th>
                                <th scope="col">Fum</th>
                                <th scope="col">INT</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(player, index) in results.Stats.Indians.Offense.Players" v-bind:key="index">
                                <td>{{player.FirstName}} {{player.LastName}}</td>
                                <td>{{player.PassingTDs}}</td>
                                <td>{{player.KickReturnTDs}}</td>
                                <td>{{player.RushingTDs}}</td>
                                <td>{{player.ReceivingTDs}}</td>
                                <td>{{player.Fumbles}}</td>
                                <td>{{player.INTs}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Boxscore',
    data() {
        return {
            results: {},
            name: "Boxscore"
        }
    },
    methods: {
        fetchBoxScore(gameid){
            fetch(`https://buhbq6w0mb.execute-api.us-east-2.amazonaws.com/Production/results/${gameid}`, {
                method: 'GET'
            })
            .then(response => response.json())
            .then(json => this.results = json.Items[0])
        }
    },
    created() {
        let gameid = this.$route.params.id
        this.fetchBoxScore(gameid)
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Boxscore.vue